// client/src/components/Reservations/components/EditReservationModal.jsx
import React, { useState } from 'react';
import ModalPortal from '../../TrippinPost/ui/ModalPortal';
import EditReservationForm from './EditReservationForm';

export default function EditReservationModal({
  reservation,
  isOpen,
  onClose,
  onSave, // (reservationId, updates) => Promise<updatedReservation>
}) {
  const [loading, setLoading] = useState(false);

  if (!isOpen || !reservation) return null;

  async function handleSave(updates) {
    setLoading(true);
    try {
      await onSave(reservation.id, updates);
      onClose?.();
    } catch (e) {
      // Parent handles toast/alerts; keep modal open
      console.error('edit_save_failed', e);
    } finally {
      setLoading(false);
    }
  }

  return (
    <ModalPortal>
      <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-[1100] p-4">
        <div className="bg-white rounded-lg max-w-2xl w-full max-h-screen overflow-hidden shadow-xl">
          {/* Header */}
          <div className="flex items-center justify-between p-4 border-b border-gray-200">
            <h2 className="text-lg font-semibold text-gray-900">Edit Reservation</h2>
            <button onClick={onClose} className="text-gray-400 hover:text-gray-600 transition-colors">
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>

          {/* Body */}
          <div className="p-4 overflow-y-auto max-h-[75vh]">
            <EditReservationForm
              reservation={reservation}
              onSave={handleSave}
              onCancel={onClose}
              loading={loading}
            />
          </div>
        </div>
      </div>
    </ModalPortal>
  );
}
